import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const Korogocho2 = () => {
  const { page } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]); // Re-run effect when page changes


  return (
    <div className={`bg-gray-600 ${loaded ? 'slide-in' : ''}`}>
      <h1 className='text-center py-4 text-3xl text-white font-location'>KOROGOCHO 2</h1>
      <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 ">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-4 gap-3">
  
        <img src="gallery/koch pt2/koch60.jpg" alt="koch 2" className={`w-full rounded-md  object-cover h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch61.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch62.jpg" alt="koch 2" className={`w-full rounded-md  object-cover h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch63.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch64.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-96 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch65.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-96 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch66.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-96 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch67.jpg" alt="koch 2" className={`w-full rounded-md  object-cover h-96 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch68.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch71.jpg" alt="koch 2" className={`w-full rounded-md  object-cover h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch73.jpg" alt="koch 2" className={`w-full rounded-md  object-cover h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch69.jpg" alt="koch 2" className={`w-full rounded-md  object-cover h-auto transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/koch pt2/koch70.jpg" alt="koch 2" className={`w-full rounded-md  object-cover  h-auto transform hover:scale-90 transition-transform duration-500 pb-6 ${loaded ? 'fade-in loaded' : ''}`} />
      
        </div>
      </div>
    </div>
  );
}

export default Korogocho2;
